const Style = {

  breadcrumbs: 'overflow-auto',
  link: `float-left cursor-pointer no-underline font-light
    hover:text-blue-400 after:content-['_/'] after:mx-2 after:text-main-500
    last:after:content-[''] text-xl text-main-500 ml-4 sm:ml-0`,
  active: 'text-main-500/60 pointer-events-none',
}

export default Style;